const secondMS = 1000
const minuteMS = secondMS * 60
const hourMS = minuteMS * 60

/**
 * 5 minutes
 */
const shortDuration = minuteMS * 5
/**
 * 20 minutes
 */
const mediumDuration = minuteMS * 20
/**
 * 3 hours
 */
const longDuration = hourMS * 3

const fiveSeconds = secondMS * 5
const tenSeconds = secondMS * 10
const fourMinutes = minuteMS * 4
const hour = hourMS
const halfHour = hourMS / 2
const day = hourMS * 12
const dayAndNight = hourMS * 24

export {
  dayAndNight,
  shortDuration,
  mediumDuration,
  longDuration,
  fiveSeconds,
  tenSeconds,
  fourMinutes,
  hour,
  halfHour,
  day,
}
